<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    @if (ineligibleAsins().length > 0) {
      <IAlert type="warning" [title]="t('sd-page.ineligible_asins', { count: ineligibleAsins().length })">
        <div class="mt-2">
          {{ ineligibleAsins().slice(0, 20).join(", ") }}{{ ineligibleAsins().length > 20 ? ", …" : "" }}
        </div>
      </IAlert>
    }

    @if (missingAsinsInSb()?.length) {
      <IAlert [title]="t('tacos-strategy.missing_asins_in_sb')" type="warning">
        {{ t("tacos-strategy.missing_asins_in_sb_description") }} <br />
        @for (asin of missingAsinsInSb(); track asin) {
          {{ asin + ($last ? "" : ", ") }}
        }
      </IAlert>
    }

    <div class="flex justify-end gap-2">
      @if (deleteProductSelection().length > 0) {
        <IButton
          color="red"
          [icon]="'icon-[lucide--trash]'"
          size="sm"
          [label]="t('common.delete')"
          [loading]="deleteProductLoading()"
          (onClick)="removeAsinsFromTacos(deleteProductSelection())"
        />
      }
      <IButton
        color="white"
        [icon]="'icon-[lucide--plus]'"
        size="sm"
        [label]="t('common.add')"
        [disabled]="isReadOnly()"
        (onClick)="openAddAsinsModal()"
      />
    </div>
    <div class="flex max-h-[30rem] min-h-0 overflow-y-auto">
      <app-asin-selection
        class="max-h-full w-full"
        ineligibilityTag="SP"
        [customList]="asinList()"
        [(selectedAsins)]="deleteProductSelection"
        [csvExport]="false"
      />
    </div>
  </div>

  <ng-template #addAsinsModal>
    <div class="relative flex h-[70vh] w-[80vw] flex-col gap-4">
      @if (addProductLoading()) {
        <div class="absolute inset-0 flex items-center justify-center">
          <app-spinner [display]="true" type="default" />
        </div>
      }

      <app-asin-selection
        class="min-h-0 flex-1"
        [ngClass]="{ 'pointer-events-none opacity-50': addProductLoading() }"
        [csvExport]="false"
        [customList]="productAvailableToAdd()"
        [(selectedAsins)]="addProductSelection"
        ineligibilityTag="SP"
      />

      <div class="flex justify-end gap-2">
        <IButton color="white" size="sm" [label]="t('common.cancel')" (onClick)="addAsinsModalRef?.close()" />
        <IButton
          size="sm"
          [label]="t('sp-substrategy.add_products')"
          (onClick)="addAsinsToTacos(addProductSelection())"
          [loading]="addProductLoading()"
          [disabled]="addProductSelection().length === 0"
        />
      </div>
    </div>
  </ng-template>
</ng-container>
